import { DatePicker, Form } from "antd";
import moment from "moment";
import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import type { ResetUserTaxCaseFormValues } from "./types";

export const initialResetUserTaxCaseValues: Partial<ResetUserTaxCaseFormValues> =
  {
    date: moment(),
  };

const getTexts = (t: TFunction) => {
  const keyPrefix = "command.resetUserTaxCase";
  return {
    date: {
      label: t(`${keyPrefix}.date.label`),
      placeholder: t(`${keyPrefix}.date.placeholder`),
    },
  };
};

export const ResetUserTaxCase: React.FC = () => {
  const { t } = useTranslation("CommandHub");
  const texts = getTexts(t);

  return (
    <Form.Item name="date" label={texts.date.label}>
      <DatePicker
        id="date"
        placeholder={texts.date.placeholder}
        picker="year"
        disabledDate={(date: moment.Moment) =>
          date && date.year() > moment().year()
        }
      />
    </Form.Item>
  );
};

export default ResetUserTaxCase;
